import { User } from 'lucide-react';

interface AdvisorBadgeProps {
  text: string;
  variant?: 'desktop' | 'mobile';
}

const AdvisorBadge = ({ text, variant = 'desktop' }: AdvisorBadgeProps) => {
  const isDesktop = variant === 'desktop';

  return (
    <div
      className={`inline-flex w-fit items-center gap-2 bg-accent-primary ${
        isDesktop ? 'rounded-[20px] px-3.5 py-1.5' : 'rounded-2xl px-3 py-1.5'
      }`}
    >
      <User className={`text-white ${isDesktop ? 'h-3.5 w-3.5' : 'h-3 w-3'}`} />
      <span
        className={`font-body font-medium text-white ${
          isDesktop ? 'text-[13px]' : 'text-[11px]'
        }`}
      >
        {text}
      </span>
    </div>
  );
};

export default AdvisorBadge;
